import styled from 'styled-components';
import getTextColor from 'helpers/getTextColor';

export default styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-transform: uppercase;
  user-select: none;
  font-weight: 400;

  ${
    props => props.$isActive && props.$innerColorActive ? `
    color: ${props => props.$innerColorActive && (props.$innerColorActive.startsWith('rgba') && !props.$innerColorActive.endsWith('0)')) && props.$innerColorActive.toLowerCase() !== 'transparent' ? getTextColor(props.$innerColor) : '#FFF'};
    ` : `
    color: ${props => props.$innerColor && (props.$innerColor.startsWith('rgba') && !props.$innerColor.endsWith('0)')) && props.$innerColor.toLowerCase() !== 'transparent' ? getTextColor(props.$innerColor) : '#6D7286'};
    `
  }

  
`;
